import { extract } from 'ricos-content/libs/extract';
import { SourceType } from '../../rules-v2';
import { createEntityItemId } from '../create-entity-item-id';
import { getSavedMediaDataById } from '../rules-data';
const AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac', 'wma', 'opus', 'webm', 'oga'];
const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp', 'ogv', 'mpg', 'mpeg', 'mts', 'ts'];
const isAudioFile = (fileType, fileId) => {
  if (fileType && AUDIO_EXTENSIONS.includes(fileType.toLowerCase())) {
    return true;
  }
  if (fileId) {
    var _fileId$split$pop;
    const extension = (_fileId$split$pop = fileId.split('.').pop()) == null ? void 0 : _fileId$split$pop.toLowerCase();
    return extension ? AUDIO_EXTENSIONS.includes(extension) : false;
  }
  return false;
};
const isVideoFile = (fileType, fileId) => {
  if (fileType && VIDEO_EXTENSIONS.includes(fileType.toLowerCase())) {
    return true;
  }
  if (fileId) {
    var _fileId$split$pop2;
    const extension = (_fileId$split$pop2 = fileId.split('.').pop()) == null ? void 0 : _fileId$split$pop2.toLowerCase();
    return extension ? VIDEO_EXTENSIONS.includes(extension) : false;
  }
  return false;
};
export const getRicosGalleryImages = (richContent, entityId) => {
  if (!richContent || !entityId || !Array.isArray(richContent.nodes)) {
    return [];
  }
  const galleryImages = extract(richContent.nodes).filter(_ref => {
    let {
      type
    } = _ref;
    return type === 'GALLERY';
  }).map(_ref2 => {
    var _items;
    let {
      id: nodeId,
      galleryData
    } = _ref2;
    return (_items = galleryData.items) == null ? void 0 : _items.map(item => {
      var _item$image, _item$image2;
      const imageId = ((_item$image = item.image) == null || (_item$image = _item$image.media) == null || (_item$image = _item$image.src) == null ? void 0 : _item$image.url) || '';
      return {
        alt: item.altText || '',
        id: createEntityItemId([entityId, nodeId], imageId),
        uri: ((_item$image2 = item.image) == null || (_item$image2 = _item$image2.media) == null || (_item$image2 = _item$image2.src) == null ? void 0 : _item$image2.url) || ''
      };
    });
  }).get().flatMap(images => images);
  return galleryImages;
};
export const getRicosImagesAltText = (richContent, entityId) => {
  if (!richContent || !entityId || !Array.isArray(richContent.nodes)) {
    return [];
  }
  return extract(richContent.nodes).filter(_ref3 => {
    let {
      type
    } = _ref3;
    return type === 'IMAGE';
  }).map(_ref4 => {
    var _imageData$image, _imageData$image2;
    let {
      id: nodeId,
      imageData
    } = _ref4;
    const imageId = (imageData == null || (_imageData$image = imageData.image) == null || (_imageData$image = _imageData$image.src) == null ? void 0 : _imageData$image.id) || '';
    return {
      alt: (imageData == null ? void 0 : imageData.altText) || '',
      id: createEntityItemId([entityId, nodeId], imageId),
      uri: (imageData == null || (_imageData$image2 = imageData.image) == null || (_imageData$image2 = _imageData$image2.src) == null ? void 0 : _imageData$image2.id) || ''
    };
  }).get();
};
export const getRicosAudios = (richContent, entityId, elementIdToSavedMediaData) => {
  if (!richContent || !entityId || !Array.isArray(richContent.nodes)) {
    return [];
  }
  const audioNodes = extract(richContent.nodes).filter(_ref5 => {
    let {
      type
    } = _ref5;
    return type === 'AUDIO';
  }).map(_ref6 => {
    var _audioData$audio;
    let {
      id: nodeId,
      audioData
    } = _ref6;
    const audioId = (audioData == null || (_audioData$audio = audioData.audio) == null || (_audioData$audio = _audioData$audio.src) == null ? void 0 : _audioData$audio.id) || '';
    const uniqueId = createEntityItemId([entityId, nodeId], audioId);
    return {
      id: uniqueId,
      sourceType: SourceType.AUDIO,
      title: (audioData == null ? void 0 : audioData.name) || '',
      type: getSavedMediaDataById(uniqueId, elementIdToSavedMediaData)
    };
  }).get();
  const fileAudioNodes = extract(richContent.nodes).filter(_ref7 => {
    var _fileData$src;
    let {
      type,
      fileData
    } = _ref7;
    return type === 'FILE' && isAudioFile(fileData == null ? void 0 : fileData.type, fileData == null || (_fileData$src = fileData.src) == null ? void 0 : _fileData$src.id);
  }).map(_ref8 => {
    var _fileData$src2;
    let {
      id: nodeId,
      fileData
    } = _ref8;
    const fileId = (fileData == null || (_fileData$src2 = fileData.src) == null ? void 0 : _fileData$src2.id) || '';
    const uniqueId = createEntityItemId([entityId, nodeId], fileId);
    return {
      id: uniqueId,
      sourceType: SourceType.AUDIO,
      title: (fileData == null ? void 0 : fileData.name) || '',
      type: getSavedMediaDataById(uniqueId, elementIdToSavedMediaData)
    };
  }).get();
  return [...audioNodes, ...fileAudioNodes];
};
export const getRicosVideos = (richContent, entityId, elementIdToSavedMediaData) => {
  if (!richContent || !entityId || !Array.isArray(richContent.nodes)) {
    return [];
  }
  const videoNodes = extract(richContent.nodes).filter(_ref9 => {
    let {
      type
    } = _ref9;
    return type === 'VIDEO';
  }).map(_ref0 => {
    var _videoData$video, _videoData$thumbnail, _videoData$thumbnail2;
    let {
      id: nodeId,
      videoData
    } = _ref0;
    const videoId = (videoData == null || (_videoData$video = videoData.video) == null || (_videoData$video = _videoData$video.src) == null ? void 0 : _videoData$video.id) || '';
    const uniqueId = createEntityItemId([entityId, nodeId], videoId);
    return {
      id: uniqueId,
      sourceType: SourceType.VIDEO,
      title: (videoData == null ? void 0 : videoData.title) || '',
      type: getSavedMediaDataById(uniqueId, elementIdToSavedMediaData),
      uri: (videoData == null || (_videoData$thumbnail = videoData.thumbnail) == null || (_videoData$thumbnail = _videoData$thumbnail.src) == null ? void 0 : _videoData$thumbnail.id) || (videoData == null || (_videoData$thumbnail2 = videoData.thumbnail) == null || (_videoData$thumbnail2 = _videoData$thumbnail2.src) == null ? void 0 : _videoData$thumbnail2.url)
    };
  }).get();
  const fileVideoNodes = extract(richContent.nodes).filter(_ref1 => {
    var _fileData$src3;
    let {
      type,
      fileData
    } = _ref1;
    return type === 'FILE' && isVideoFile(fileData == null ? void 0 : fileData.type, fileData == null || (_fileData$src3 = fileData.src) == null ? void 0 : _fileData$src3.id);
  }).map(_ref10 => {
    var _fileData$src4;
    let {
      id: nodeId,
      fileData
    } = _ref10;
    const fileId = (fileData == null || (_fileData$src4 = fileData.src) == null ? void 0 : _fileData$src4.id) || '';
    const uniqueId = createEntityItemId([entityId, nodeId], fileId);
    return {
      id: uniqueId,
      sourceType: SourceType.VIDEO,
      title: (fileData == null ? void 0 : fileData.name) || '',
      type: getSavedMediaDataById(uniqueId, elementIdToSavedMediaData)
    };
  }).get();
  return [...videoNodes, ...fileVideoNodes];
};
//# sourceMappingURL=ricos-extractor.js.map